export const appTransactions = {
  name: 'App Transaction |||| App Transactions',
  fields: {
    id: 'Transaction ID',
    user_id: 'User ID',
    amount: 'Amount',
    type: 'Type',
    status: 'Status',
    payment_method: 'Payment Method',
    reference_id: 'Reference ID',
    description: 'Description',
    metadata: 'Metadata',
    created_at: 'Created At',
    updated_at: 'Updated At',
    timestamp: 'Timestamp',
    user: {
      name: 'User Name',
      email: 'User Email',
    },
  },
  types: {
    topup: 'Top Up',
    deduction: 'Charging',
    pre_auth: 'Pre-Authorization',
    refund: 'Refund',
    reward: 'Reward',
    adjustment: 'Balance Adjustment',
    all: 'All Types',
  },
  statuses: {
    pending: 'Pending',
    completed: 'Completed',
    failed: 'Failed',
    cancelled: 'Cancelled',
    hold: 'Hold',
    released: 'Released',
    processing: 'Processing',
    all: 'All Status',
  },
  paymentMethods: {
    wallet: 'Wallet',
    credit_card: 'Credit Card',
    rfid: 'RFID',
    qr_code: 'QR Code',
  },
  filters: {
    search: 'Search',
    type: 'Transaction Type',
    status: 'Status',
    from_date: 'From Date',
    to_date: 'To Date',
    min_amount: 'Minimum Amount',
    max_amount: 'Maximum Amount',
  },
  summary: {
    total_transactions: 'Total Transactions',
    net_amount: 'Net Amount',
    completed: 'Completed',
    pending_failed: 'Pending / Failed',
  },
  actions: {
    export: 'Export CSV',
    refresh: 'Refresh',
  },
  messages: {
    exportSuccess: 'Transactions exported successfully',
    exportFailed: 'Failed to export transactions',
    refundSuccess: 'Refund processed successfully',
    refundFailed: 'Failed to process refund',
  },
  show: {
    title: 'Transaction Details',
    transactionInfo: 'Transaction Information',
    userInfo: 'User Information',
    paymentDetails: 'Payment Details',
    chargingSessionDetails: 'Charging Session Details',
    adminNotes: 'Admin Notes',
    transactionId: 'Transaction ID',
    type: 'Type',
    status: 'Status',
    amount: 'Amount',
    dateTime: 'Date/Time',
    paymentMethod: 'Payment Method',
    referenceType: 'Reference Type',
    referenceId: 'Reference ID',
    userId: 'User ID',
    name: 'Name',
    email: 'Email',
    sessionId: 'Session ID',
    charger: 'Charger',
    site: 'Site',
    energyDelivered: 'Energy Delivered',
    startTime: 'Start Time',
    endTime: 'End Time',
    duration: 'Duration',
    finalCost: 'Final Cost',
    inProgress: 'In Progress',
    minutes: 'minutes',
    processRefund: 'Process Refund',
    refundAmount: 'Refund Amount',
    refundReason: 'Refund Reason',
    maximum: 'Maximum',
    cancel: 'Cancel',
    refundWarning: 'This will refund the transaction amount to the user\'s wallet balance.',
  },
};